module.exports = __webpack_public_path__ + "img/RIREKI_SILVER.4dc3210e.png";